document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".complete-look-card").forEach((card) => {

    const button = card.querySelector(".complete-look-add");
    const sizes = card.querySelectorAll(".complete-look-size");

    if (!button) return;

    sizes.forEach(size => {

      size.addEventListener("click", () => {

        if (size.classList.contains("disabled")) return;

        sizes.forEach(s => s.classList.remove("active"));

        size.classList.add("active");

        button.dataset.variantId = size.dataset.variantId;

      });

    });

    button.addEventListener("click", () => {

      button.disabled = true;
      button.innerHTML = "Adding...";

      fetch("/cart/add.js", {

        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify({
          id: button.dataset.variantId,
          quantity: 1
        })

      })

      .then(r => r.json())

      .then(() => {

        button.innerHTML = "✓ Added";
        button.classList.add("added");

        document.dispatchEvent(new CustomEvent("cart:refresh"));

        setTimeout(() => {

          button.disabled = false;
          button.classList.remove("added");
          button.innerHTML = "Add To Cart";

        }, 1800);

      })

      .catch(() => {

        button.disabled = false;
        button.innerHTML = "Try Again";

      });

    });

  });

});